import { LAST_NAME_KEY } from '@esentai/core/features/users/consts/keys';
import { annotations } from '@esentai/core/features/users/serializer';
import { ascending } from '@esentai/core/query-dsl';
import { sort } from '@esentai/core/serializers/params';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: ascending(LAST_NAME_KEY),
  }),
});
